module.exports = __webpack_public_path__ + "static/img/ctjiedudiyiimg2.be29bc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctjiedudiyiimg2.png
// module id = w2+S
// module chunks = 5